import React from 'react'
import { Alert, CloseButton, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSessionStorage } from 'react-use'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { routesDef } from '../../config/routes'
import { storageKeys } from '../../config/StorageKeys'
import { useActiveQuotation } from '../../hooks/useActiveQuotation'

export const OrderAlert = () => {
  const { loggedIn, hasActiveQuotation, latestQuotationId } = useActiveQuotation()
  //session-scoped dismiss; a real boolean — falsy/missing means "not hidden"
  const [hiddenOrderAlert, setHiddenOrderAlert] = useSessionStorage(storageKeys.hideOrderAlert, false)

  const showAlert = loggedIn && hasActiveQuotation && !hiddenOrderAlert

  const onClose = () => setHiddenOrderAlert(true)

  //deep-link straight to the latest active quotation's detail page (fallback to the list while the id loads)
  const quotationTo = latestQuotationId
    ? routesDef.AccountOrderItem.altPath({ _id: latestQuotationId })
    : routesDef.AccountOrders.altPath({ activeTab: 'quotation' })

  return (
    <ShowIf condition={showAlert}>
      <Alert variant="warning" className="mb-0 py-1" show={true}>
        <Container className="d-flex align-items-center gap-2 small mb-0">
          <Icon name="triangle-exclamation" />
          <span>Your quotation is ready for you — finish it to move your order forward.</span>
          {/* navigates only — viewing the quotation must NOT dismiss the banner; only the close button does */}
          <Link to={quotationTo}>View Quotation</Link>
          <span className="text-body-secondary">· No longer needed? Open and cancel it.</span>
          {/* inline, ms-auto — a plain CloseButton (~1em) sits on the thin bar; react-bootstrap's
              `dismissible` instead injects an absolutely-positioned .btn-close with large padding
              that overflows the py-1 bar into the header */}
          <CloseButton className="ms-auto" aria-label="Close" onClick={onClose} />
        </Container>
      </Alert>
    </ShowIf>
  )
}
